module.exports = __webpack_public_path__ + "static/profile_sm-2185a05884f23e6cc84a338fcdf8f79f.png";